module.exports = __webpack_public_path__ + "img/banner-semana-santa-mapgrafi.4ee020be.jpg";